import styled from '../../../theme/theme';

export const LegendIndicator = styled.div(({ theme }) => ({
  height: 4,
  width: 12,
  borderRadius: 4,
  marginBottom: 4,
  marginRight: 4,
  background: theme.colors.primary[500],
}));
